import { Button, Input, Space } from "antd"
import { SearchOutlined } from "@ant-design/icons"
import Highlighter from "react-highlight-words"
import React, { useState } from "react"
import { getValueByPath } from "../utils"

const useColumnSearch = ({ dataIndex, transformer }) => {
  let searchInput

  const [searchText, setSearchText] = useState("")
  const [searchedColumn, setSearchedColumn] = useState("")

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = clearFilters => {
    clearFilters()

    setSearchText("")
  }

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            searchInput = node
          }}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Cerca
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reimposta
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    // onFilter: (value, record) =>
    //   record[dataIndex]
    //     ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
    //     : "",
    onFilter: (value, record) => {
      const finalValue = transformer
        ? transformer(record)
        : getValueByPath(record, dataIndex)?.toString() ?? ""

      return finalValue.toLowerCase().includes(value.toLowerCase())
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput.select(), 100)
      }
    },
    render: record => {
      let parts = dataIndex.split(".")
      let value = record
      if (parts.length > 1) {
        // parts.shift();
        value = getValueByPath(record, parts.join("."))
      }

      if (transformer) {
        value = transformer(record)
      }

      return searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={value ? value.toString() : ""}
        />
      ) : (
        value
      )
    },
  }
}

export default useColumnSearch
